import { useEffect, useState } from 'react';

import { AuthService } from '@shared/lib/services';
import { selectIsAuth } from '@entities/user';
import { useAppDispatch, useAppSelector } from '@shared/model/hooks';
import { logout, useLazyAuthQuery, useRefreshMutation } from '@entities/user';
import toast from 'react-hot-toast';

export const useAuth = () => {
  const dispatch = useAppDispatch();
  const [authAsync] = useLazyAuthQuery();
  const [refreshAsync] = useRefreshMutation();
  const [isLoading, setIsLoading] = useState(true);
  const isAuth = useAppSelector(selectIsAuth);

  const logoutUser = () => {
    setIsLoading(false);
    dispatch(logout());
  };

  useEffect(() => {
    (async () => {
      try {
        const { accessToken, refreshToken, userId } = AuthService.getCredentialsFromLocalStorage();

        if (!accessToken || !refreshToken || !userId) {
          logoutUser();
          setIsLoading(false);

          return;
        }

        const { isError } = await authAsync(accessToken);

        if (isError) {
          await refreshAsync({
            refreshToken: refreshToken ?? '',
            userId: userId ?? '',
          }).unwrap();
        }

        setIsLoading(false);
      } catch (error) {
        toast.error('Failed to authenticate user.');
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isAuth,
    isLoading,
  };
};
